import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../../route';

// TEMPORARY redirect — remove after all tenants migrate to OMS v3.
// The Discounts v2 group review moved to /discounts/$groupId; stale links
// (e.g. from activity feeds and emails) must keep working.
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/discounts-v2/$groupId',
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/discounts/$groupId', params, search: true });
  },
});
